import React from "react";
import CustomButton from "../../../components/ui/button";
import FieldLabel from "../../../components/label";
import Header from "../../../components/header";
import SectionTitle from "../../../components/sectionTitle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Alert, Box, Dialog, DialogTitle, Grid } from "@mui/material";
import {
  BUTTON_RETRY,
  BUTTON_TERMINATE,
  SLUG_RETRY,
  SLUG_TERMINATE,
} from "../../../constants";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";

const RetryAssessment = ({
  classes: { containerButton, formGroup },
  onClose,
  modal,
  modalKey = SLUG_RETRY,
}) => {
  return (
    <Dialog
      onClose={(event, reason) => onClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal.retry}
      fullScreen={true}
      fullWidth={true}
      maxWidth={"lg"}
    >
      <Header onClick={() => {}} title={""} isBackButtonVisible={false} />
      <DialogTitle id="simple-dialog-title">
        <Box display="flex" justifyContent="center">
          <SectionTitle
            hideBack={true}
            title={"Health Assessment Result"}
            onClickHandler={(event, reason) => onClose(event, reason, modalKey)}
          />
        </Box>
      </DialogTitle>

      <Box m={1}>
        <Box className={formGroup}>
          <Alert color="warning" severity="info">
            Your health assessment has been unfortunately failed. Would you like
            to retry the assessment or terminate the journey?
          </Alert>
          {/* <FieldLabel label="Your health assessment has been unfortunately failed. Would you like
            to retry the assessment or terminate the journey?" /> */}
        </Box>

        <Box className={containerButton} sx={{ bottom: "0px" }}>
          <Box layout="column">
            <Grid container spacing={1} mb={1}>
              <Grid item xs={12}>
                <CustomButton
                  type="button"
                  size="medium"
                  color="secondary"
                  title={BUTTON_RETRY}
                  clickHandler={(event, reason) =>
                    onClose(event, reason, modalKey, SLUG_RETRY)
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <CustomButton
                  type="button"
                  size="medium"
                  color="warning"
                  variant="outlined"
                  title={BUTTON_TERMINATE}
                  clickHandler={(event, reason) =>
                    onClose(event, reason, modalKey, SLUG_TERMINATE)
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default withStyles(useStyles, { withTheme: true })(RetryAssessment);
